import React, { Component } from "react"
// import { useHistory } from 'react-router-dom'
import { getGeneralList } from "services/generalList"
import GeneralLayout from 'layouts/GeneralLayout/index'
import Item from "./Item"
import Share from "./Share"
import config from "config/default"
// import { COVER_PATH } from 'routes/path'
import NETImage from 'components/net-image'

/**
 * 课程主题页
 */
export default class GeneralListRoute extends Component {
    state = {
        pageData: null,
    }
    componentDidMount() {
        this.initPage();
    }

    get theme() {
        const { theme = 'xh' } = this.props.match.params
        return theme
    }
    
    async initPage() {
        // console.log(this.theme)
        // 获取数据
        const pageData = await getGeneralList({
            theme: this.theme,
        });
        if (pageData) {
            // 设置内容展示
            this.setState({
                pageData: pageData,
            });
        }

        // console.log('GeneralListData', GeneralListData)
        if (pageData && pageData.pageInfo && pageData.pageInfo.title) {
            document.title = pageData.pageInfo.title;
        }
    }

    render() {
        let pageData = this.state.pageData;
        const onSelect = () => {
            // history.push(COVER_PATH())
            window.location.href = pageData.firstInfo.linkUrl;
        }

        // 图片路径
        let imgPrefix = 'generalList/' + this.theme + '/';

        // console.log('pageData', pageData)
        // 分享设置
        let configs;
        if (pageData && pageData.shareInfo) {
            configs = {
                ...config,
                ...pageData.shareInfo,
                imgUrl: pageData.shareInfo.imgUrl ? config.cdnUrl + '/' + imgPrefix + pageData.shareInfo.imgUrl : undefined,
            };
        }

        return (
            pageData && <GeneralLayout pageInfo={pageData.pageInfo} className="general_page">
                <Share config={configs} />
                <div className="first_item" onClick={onSelect}>
                    <div className="img_box">
                        {/* <img src={pageData.firstInfo.imgUrl} alt="" className="img" /> */}
                        <NETImage
                            prefix={imgPrefix}
                            useAutoHeight
                            src={pageData.firstInfo.imgUrl}
                            className='img'
                        />
                    </div>
                    <div className="text">{pageData.firstInfo.title}</div>
                </div>

                <div className="list">
                    {
                        pageData.listInfo.map((item, i) => (
                            <Item key={this.theme + '_' + i} item={item} theme={imgPrefix} />
                        ))
                    }
                </div>
            </GeneralLayout>
        )
    }
}